// Квадратчето-отметка на списъците с отметки (филтри, плащане, „Целият
// списък", стоковите към фактура). Само визуално — редът около него е бутонът.
// Отметката е svg (не antd иконка): antd носи собствен line-height и тикчето
// излизаше изместено.

type Props = {
  checked: boolean;
  // „частично" — някои от групата са отметнати (заглавието в Плащане)
  indeterminate?: boolean;
  tone?: "brand" | "ok";
};

export const CheckBox = ({ checked, indeterminate = false, tone = "brand" }: Props) => {
  const on = checked || indeterminate;
  const onClass =
    tone === "ok" ? "border-ok-solid bg-ok-solid" : "border-brand bg-brand";
  return (
    <span
      aria-hidden="true"
      className={`flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-[5px] border-[1.5px] ${
        on ? onClass : "border-fill-3 bg-surface"
      }`}
    >
      {checked && (
        <svg
          viewBox="0 0 14 14"
          className="block h-[11px] w-[11px]"
          fill="none"
          stroke="#fff"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 7.3 L5.7 10 L11 4.2" />
        </svg>
      )}
      {!checked && indeterminate && <span className="h-0.5 w-2 rounded bg-white" />}
    </span>
  );
};

export default CheckBox;
